import styled from 'styled-components';
import { TextOverflow } from '@ardoq/popovers';
import { header4 } from '@ardoq/typography';
import { colors, s16, s8 } from '@ardoq/design-tokens';

const WidgetTitle = styled(TextOverflow)`
  ${header4};
  color: ${colors.textDefault};
`;

export const EditModeWidgetTile = styled(WidgetTitle)`
  margin: 0 ${s8};
`;

export const ViewModeWidgetTitle = styled(WidgetTitle)`
  margin: 0 ${s8} 0 ${s16};
`;

export const WidgetTitleWithInfo = styled(WidgetTitle)`
  display: flex;
  gap: ${s8};
  align-items: center;
`;
